<template>
  <div class="newsDetail">
    <top-nav></top-nav>
    <div class="nDetail clearfix">
    	<div class="nDetailLeft clearfix">
        	<div class="nDetailTab">
            <ul class="clearfix">
              <li :class="{current:tab==1}" @click="toTab(1)">睿哲新闻</li>
              <li :class="{current:tab==2}" @click="toTab(2)">行业新闻</li>
            </ul>
          </div>
            
          <div class="nDetailTabIn">
            <ul class="clearfix">
              <li :class="selectIndex === index && selectItem === item.id ? 'select-list-color' : null" v-for="(item,index) in tabContent" :key="'tabContent'+index" @click="getDetail(item.id,index)">
                <a>
                  <div class="nDetailDate">
                    <ul class="clearfix">
                      <li>{{item.createTime | getDay}}</li>
                      <li>{{item.createTime | getYearMouth}}</li>
                    </ul>
                    </div>
                    <div class="nDetailCon">
                      <div class="nTabTit">{{item.title}}</div>
                      <div class="nTabMain">{{item.summary}}</div>
                    </div>
                    </a>
                </li>
              </ul>
          </div>
        </div>
        <div class="nDetailRight">
			<div class="nDetailTit">{{detailData.title}}</div>
			<div class="nDetailOther">
				<i></i><span>时间：{{detailData.createTime}}</span>
				<i></i><span>{{detailData.creator}}</span>
			</div>
			<div class="nDetailMain" id="newsContentDiv" v-html="detailData.content"></div>
		</div>
    </div>

    <bottom-footer></bottom-footer>
  </div>
</template>

<script>
import topNav from "@/components/topNav";
import bottomFooter from "@/components/bottomFooter.vue";
import banner from "@/components/banner.vue";

export default {
  name: "newsDetail",
  data() {
    return {
      bgImage:'../../../static/images/businessBanner.jpg',
      showMask: false,
      detailData: '',
      tab: 1,
      tabContent: '',

      selectIndex:null,
      selectItem:this.$route.query.id,
    };
  },
  components: {
    topNav,
    bottomFooter,
    banner,
  },
  mounted() {
    this.getDetail(this.$route.query.id);
    this.getTabContent(1);
  },

  methods: {
    toTab(num){
      this.tab = num;
      
      this.getTabContent(num)
    },
    getDetail(id,index){
      this.selectItem = id
      this.selectIndex = index
      let params = {
        id: id,
      }
      this.$axios.get('api/gw/findByIdForNew',{params}).then((data)=>{
        this.detailData = data.data.data
      }).catch((err)=>{
        console.log(err);
      })
    },
    getTabContent(num){
      let url = '/api/gw/findAllRzNews'
      if(num==1){
         url = '/api/gw/findAllRzNews'
      }else{
        url = '/api/gw/findAllHyNews'
      }
      let params = {
        page: 1,
        pageSize: 6
      }
      this.$axios.get(url,{params}).then((data)=>{
        this.tabContent = data.data.data.list
      }).catch((err)=>{
        console.log(err);
      })
    },
  },

  filters: {
    getDay(val){
      if (!val) {
         return ''
      }else{
        let time = val.split(' ')[0];
        let arr = time.split('-')
        return arr[2]
      }
    },
    getYearMouth(val){
      if (!val) {
         return ''
      }else{
        let time = val.split(' ')[0];
        let arr = time.split('-')
        return arr[0] + '-' + arr[1]
      }
    },
  
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../../assets/css/quill.bubble";
@import "../../assets/css/global";
.newsDetail {
  img{
    max-width: 100%;
  }
  .nDetail {
    width: 1200px;
    height: auto;
    padding: 60px 0;
    margin: 0 auto;
    min-height: 736px;
    .nDetailLeft {
      width: 300px;
      height: auto;
      float: left;
      margin-right: 78px;
      .nDetailTab {
        width: 300px;
        height: 37px;
        li {
          width: 150px;
          height: 37px;
          line-height: 35px;
          color: #818181;
          font-size: 16px;
          text-align: center;
          border: 1px solid #e4e4e4;
          border-bottom: 2px solid #73a9f1;
          float: left;
          cursor: pointer;
          &.current {
            background-color: #73a9f1;
            color: #fff;
            border: 0;
            border-bottom: 2px solid #73a9f1;
          }
          &:nth-of-type(1) {
            border-right: 0;
          }
          &:nth-of-type(2) {
            border-left: 0;
          }
        }
      }
      .nDetailTabIn {
        width: 100%;
        height: auto;
        padding: 0 8px;
        border: 1px solid #e4e4e4;
        margin-top: -1px;
        .select-list-color{
          background-color: skyblue;
          color: #e4e4e4;
        }
        li {
          width: 100%;
          height: 85px;
          padding: 15px 0;
          border-bottom: 1px solid #e4e4e4;
          cursor: pointer;
          .nDetailDate {
            width: 54px;
            height: 54px;
            padding: 13px 3px 0;
            background: url('../../../static/images/date.png') no-repeat center;
            margin-right: 12px;
            float: left;
            li:nth-of-type(1) {
              height: 19px;
              line-height: 18px;
              color: #8c8c8c;
              text-align: center;
              border-bottom: 1px solid #c1c1c1;
              padding: 0;
            }
            li:nth-of-type(2) {
              height: 20px;
              line-height: 20px;
              font-size: 12px;
              color: #8c8c8c;
              text-align: center;
              padding: 0;
            }
            .nDetailTabIn li:last-of-type {
              border-bottom: 0;
            }
          }
          .nDetailCon {
            width: 216px;
            height: 54px;
            float: left;
            padding: 8px 0;
            .nTabTit {
              width: 100%;
              height: 22px;
              line-height: 14px;
              padding-bottom: 8px;
              color: #5b5b5b;
              overflow:hidden;
              text-overflow:ellipsis;
              white-space:nowrap
            }
            .nTabMain {
              width: 100%;
              height: 28px;
              font-size: 12px;
              color: #818181;
              text-align: justify;
              text-indent: 24px;
              overflow:hidden;
              text-overflow:ellipsis;
              white-space:nowrap
            }
          }
        }
      }
    }
    .nDetailRight {
      width: 822px;
      height: auto;
      float: left;
      border: 1px solid #e4e4e4;
      padding: 25px 15px;
      .nDetailTit {
        width: 100%;
        min-height: 24px;
        line-height: 24px;
        color: #73a9f1;
        font-size: 24px;
      }
      .nDetailOther {
        width: 100%;
        height: 36px;
        line-height: 35px;
        color: #818181;
        border-bottom: 1px solid #e4e4e4;
        i {
          width: 15px;
          height: 14px;
          margin-right: 5px;
          display: inline-block;
          background: url('../../../static/images/time-s.png') no-repeat center;
          vertical-align: middle;
          margin-top: -3px;
          &:nth-of-type(2) {
            background: url('../../../static/images/author-s.png') no-repeat center;
          }
        }
        span {
          margin-right: 15px;
        }
      }
      .nDetailMain {
        width: 100%;
        height: auto;
        line-height: 30px;
        color: #818181;
        text-align: justify;
        font-size: 16px;
        padding: 20px 0;
        //text-indent: 32px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/news/newsDetail.vue